import { popError } from "./Popup";

class Payload {
    route: string = '';
    payload: any = [];

}
export async function api<T>(
    route: string,
    payload: Record<string, any> = {}
): Promise<T | false> {

    const pload = new Payload;
    pload.route = route;
    pload.payload = payload;

    const body = JSON.stringify(pload);
    try {
        const resp = await fetch('/api.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json; charset=utf-8'
            },
            credentials: 'include',
            body
        });

        if (!resp.ok) {
            popError( `${route}: HTTP ${resp.status} ${resp.statusText} `);
            return false;
        }

        const json = await resp.json();
        
        // Validera API‑formatet
        if (typeof json !== 'object' || json.ok === undefined) {
            popError( `${route}: Invalid API response format`);
            return false;
        }

        if (!json.ok) {
            popError(json.data ?? `${route} Unknown Error`);
            return false;
        }

        try {
            const reply = json.data as T;
            if( reply === undefined ) {
                popError(`${route}: Could not translate reply`);
            }
            return reply;
        }
        catch( e: any) {
            popError(`${route}: Could not translate reply ${e.message}`);
            return false;
        }
        
    }
    catch (err: any) {
        popError(`API‑fel (${route}): ${err.message}`);
        return false;
    }
}

